// User
export const SEARCH_USERS_REQUESTED = 'SEARCH_USERS_REQUESTED';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_ERROR = 'SEARCH_USERS_ERROR';
export const USER_TENANTS_REQUESTED = 'USER_TENANTS_REQUESTED';
export const USER_TENANTS_SUCCESS = 'USER_TENANTS_SUCCESS';
export const USER_TENANTS_ERROR = 'USER_TENANTS_ERROR';
export const USER_LEAVE_TENANT_REQUESTED = 'USER_LEAVE_TENANT_REQUESTED';
export const USER_LEAVE_TENANT_SUCCESS = 'USER_LEAVE_TENANT_SUCCESS';
export const USER_LEAVE_TENANT_ERROR = 'USER_LEAVE_TENANT_ERROR';
export const ME_REQUESTED = 'ME_REQUESTED';
export const ME_SUCCESS = 'ME_SUCCESS';
export const ME_ERROR = 'ME_ERROR';
export const UPDATE_USER_REQUESTED = 'UPDATE_USER_REQUESTED';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const USER_TUTORIALS_REQUESTED = 'USER_TUTORIALS_REQUESTED';
export const USER_TUTORIALS_SUCCESS = 'USER_TUTORIALS_SUCCESS';
export const USER_TUTORIALS_ERROR = 'USER_TUTORIALS_ERROR';
export const UPDATE_USER_TUTORIALS_REQUESTED = 'UPDATE_USER_TUTORIALS_REQUESTED';
export const UPDATE_USER_TUTORIALS_SUCCESS = 'UPDATE_USER_TUTORIALS_SUCCESS';
export const UPDATE_USER_TUTORIALS_ERROR = 'UPDATE_USER_TUTORIALS_ERROR';
